module.exports = ["增值税专用发票","增值税专用发票","普通发票","个人发票"]


//////////////////
// WEBPACK FOOTER
// ./src/config/invoice.json
// module id = qh/q
// module chunks = 1